import React from 'react';

function ToolToggleList({ tools = [], onToggle }) {
  return (
    <ul className="tool-toggle-list">
      {tools.map((tool) => (
        <li key={tool.id}>
          <span>{tool.label}</span>
          <button
            aria-checked={tool.enabled}
            aria-label={`Toggle ${tool.label}`}
            className={`toggle-switch ${tool.enabled ? 'is-on' : ''}`}
            onClick={() => onToggle(tool.id)}
            role="switch"
            type="button"
          >
            <span />
          </button>
        </li>
      ))}
    </ul>
  );
}

export default ToolToggleList;
